import { Box, Card, CircularProgress } from '@mui/material';
import FormHelperText from '@mui/material/FormHelperText';
import { H6, Tiny } from 'components/Typography';
import UploadOnCloud from 'icons/UploadOnCloud';
import { useDropzone } from 'react-dropzone';
const FileUpload = ({
    onDrop,
    error,
    // handleRemoveImage,
    file,
}) => {
    const { getRootProps, getInputProps } = useDropzone({
        accept: {
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                ['.xlsx'],
        },
        maxSize: 5000000,
        onDrop,
    });
    return (
        <Card
            sx={{
                padding: 3,
            }}
        >
            {file ? (
                <>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        <CircularProgress color="success" />
                        <Tiny fontWeight={600}>
                            Please wait, your file is being processing ...
                        </Tiny>
                    </Box>
                </>
            ) : (
                <Box
                    {...getRootProps({
                        className: 'dropzone',
                    })}
                    sx={{
                        padding: 3,
                        cursor: 'pointer',
                        textAlign: 'center',
                    }}
                >
                    <UploadOnCloud
                        sx={{
                            fontSize: 38,
                            color: 'text.disabled',
                        }}
                    />
                    <Tiny fontWeight={600}>Drop your file here or</Tiny>
                    <H6 fontSize={12} color="primary.main">
                        Select click to browse
                    </H6>
                    {error && (
                        <FormHelperText
                            sx={{ color: 'error.main', textAlign: 'center' }}
                        >
                            {error}
                        </FormHelperText>
                    )}
                    <input
                        {...getInputProps()}
                        placeholder="Select click to browse"
                    />
                </Box>
            )}
        </Card>
    );
};

export default FileUpload;
